// common.js
// const API_BASE_URL = "http://localhost:8000/AppsRaidLogUI";
//const API_BASE_URL = 'https://x9d42ivr8j.execute-api.us-east-1.amazonaws.com/prod/AppsRaidLogUI';
//const API_BASE_URL = 'https://v8vnflpv6g.execute-api.us-east-1.amazonaws.com/prod/AppsRaidLogUI';
//Test
//const API_BASE_URL = 'https://ddpnlrmrnvkahlta7fw4yxrtpa.apigateway.us-ashburn-1.oci.customer-oci.com/AppsRaidLogUI';

// #PROD
const API_BASE_URL = 'https://hlxvxjqcc5qwtleretfwmhjzta.apigateway.us-ashburn-1.oci.customer-oci.com/AppsRaidLogUI';
export default API_BASE_URL;



// API Base URL - configured via environment variable
//const API_BASE_URL = API_BASE_URL || process.env.REACT_APP_API_BASE_URL ||
//  process.env.REACT_APP_BACKEND_URL ||
//  'http://localhost:8000/AppsRaidLogUI';

